(() => {
  const normalize = (text) => text.toLocaleLowerCase('tr').replace(/ı/g, 'i')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
  let vehicleIndex;

  function suggest(input) {
    const list = input.list;
    if (!list) return;
    vehicleIndex ||= (window.KeudohaVehicleModels || []).map((name) => [name, normalize(name)]);
    const query = normalize(input.value);
    const matches = query.length < 2 ? [] : vehicleIndex.filter(([, key]) => key.includes(query)).slice(0, 18);
    list.replaceChildren(...matches.map(([name]) => new Option(name, name)));
  }

  function update(panel) {
    const result = panel.querySelector('[data-kg-result]');
    const answers = [...panel.querySelectorAll('[data-kg-condition]')].map((input) => input.value);
    let state = 'wait';
    if (answers.includes('no')) state = 'no';
    else if (answers.includes('unknown')) state = 'unknown';
    else if (answers.length && answers.every((answer) => answer === 'yes')) state = 'ready';

    const vehicle = [panel.querySelector('[data-kg-model]')?.value.trim(),
      panel.querySelector('[data-kg-year]')?.value].filter(Boolean).join(' · ');
    result.dataset.state = state;
    result.textContent = (state !== 'wait' && vehicle ? vehicle + ' — ' : '') + result.dataset[state];
  }

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-kg-model]')) {
      suggest(event.target);
      update(event.target.closest('[data-kg-fit]'));
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-kg-condition], [data-kg-year], [data-kg-model]')) {
      update(event.target.closest('[data-kg-fit]'));
    }
  });
})();
